// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"694":"f5b875aa","946":"f5b875aa"}[chunkId] + ".chunk.css";
};